// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import { type GetArticlesListData, type GetArticlesListError, type GetArticlesListResponse, GetArticlesListResponseTransformer } from './types.gen';

export const client = createClient(createConfig());

/**
 * Получение списка статей и достопримечательностей
 */
export const getArticlesList = <ThrowOnError extends boolean = false>(options?: Options<GetArticlesListData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetArticlesListResponse, GetArticlesListError, ThrowOnError>({
        ...options,
        url: '/service/journal/api/v1/articles',
        responseTransformer: GetArticlesListResponseTransformer
    });
};